import { Analytics } from '@cobliteam/analytics';
import { Location } from '@cobliteam/common-types';
import { useTranslation } from '@cobliteam/i18n';
import { Button, DropdownMenu, Tooltip } from '@cobliteam/ui/components';
import Icon from '@cobliteam/ui/icons';
import { useHistory } from 'react-router-dom';

const HowToUseButton = () => {
  const { t } = useTranslation('app-header');
  const history = useHistory();

  return (
    <DropdownMenu>
      <Tooltip content={t('help.tooltip')} position='right' asChild>
        <DropdownMenu.Trigger asChild>
          <Button
            data-testid='app-header-how-to-use-button'
            className='text-default hover:text-brand'
            variant='ghost'
            color='primary'
            size='sm'
            icon={<Icon name='circle-help' />}
            onClick={() => Analytics.track('NavBar - HowToUse - Click')}
          />
        </DropdownMenu.Trigger>
      </Tooltip>
      <DropdownMenu.Content align='end' side='right' sideOffset={10}>
        <DropdownMenu.Item
          onClick={() => {
            window.open('https://suporte.cobli.co/');
            Analytics.track('NavBar - HelpCenter - Click');
          }}
        >
          <DropdownMenu.Icon icon={<Icon name='circle-help' />} />
          <DropdownMenu.Label>{t('help.helpCenter')}</DropdownMenu.Label>
        </DropdownMenu.Item>

        <DropdownMenu.Item
          onClick={() => {
            history.push(Location.TRAINING);
            Analytics.track('NavBar - Training - Click');
          }}
        >
          <DropdownMenu.Icon icon={<Icon name='graduation-cap' />} />
          <DropdownMenu.Label>{t('help.training')}</DropdownMenu.Label>
        </DropdownMenu.Item>

        <DropdownMenu.Item
          onClick={() => {
            window.open('https://suporte.cobli.co/contato-cobli');
            Analytics.track('NavBar - Contact - Click');
          }}
        >
          <DropdownMenu.Icon icon={<Icon name='headset' />} />
          <DropdownMenu.Label>{t('help.contact')}</DropdownMenu.Label>
        </DropdownMenu.Item>
      </DropdownMenu.Content>
    </DropdownMenu>
  );
};

export default HowToUseButton;
